import React, { useState, useEffect } from 'react';
import './EvaluationDetails.css';
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom'
import { deleteEvaluationByReader, emptyEvaluationDetails, loadEvaluationDetails } from '../../../store/Actions/ActionEvaluationDetails'
import { useLocation, useParams } from 'react-router-dom';
import { postCreativeWorkStatus } from '../../../store/Actions/ActionCreativeWork';
import ScriptFiles from './ScriptFiles';
import ScriptInfo from './ScriptInfo';
import { UsePermissions, hasPermissions } from '../../general/general-component/abstruct-component/UsePermissions';
import CheckPermissions from '../../general/general-component/check-permissions';

const EvaluationDetails = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const project_requests = hasPermissions([{ name: "project-requests" }], permissionss)
    let { creativeWorkId } = useParams()
    const [isLoading, setLoading] = useState(false);
    const [tab, setTab] = useState('evaluation')
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const [loadDel, setloadDel] = useState(false)
    const [reader_id, setreader_id] = useState(false)
    const { evaluationDetails, loadingevaluationDetails } = useSelectorCustom()
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState('');
    const [popUpActive, setPopUpActive] = useState(false);
    const location = useLocation();
    const arr = location.state.arr;

    const getBackgroundColor = (evaluation) => {
        switch (evaluation) {
            case 'unacceptable':
                return 'unacceptable';
            case 'poor':
                return 'poor';
            case 'satisfactory':
                return 'satisfactory';
            case 'good':
                return 'good';
            case 'excellent':
                return 'excellent';
            default:
                return '#FFFFFF';
        }
    };

    useEffect(() => {
        dispatch(loadEvaluationDetails(creativeWorkId))
        return (() => {
            dispatch(emptyEvaluationDetails())
        })
    }, []);


    const handleDelete = (reader_id) => {
        setreader_id(reader_id)
        dispatch(deleteEvaluationByReader(reader_id, creativeWorkId, setloadDel));
    }

    const handelStatusChange = (status) => {
        setStatus(status);
        if (status == 'accepted' || status == 'reject') {
            setPopUpActive(true);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postCreativeWorkStatus(creativeWorkId, status, message));
        setPopUpActive(false);
    };

    const handleEvaluationDetails = (event, id) => {
        event.preventDefault();
        navigate(`/project-request/${creativeWorkId}/details/${id}/details`);
    };

    return (
        <>
            <CheckPermissions array={project_requests} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className='all_evaluations_details'>
                        <div className='head_with_title' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                            <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => setTab('evaluation')} >{translate('evaluations')}</span>
                            <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => setTab('script_files')} >{translate('script-files')}</span>
                            <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => setTab('script_info')} >{translate('script-info')}</span>
                        </div>
                        {
                            tab === 'evaluation' && (
                                <div className="container-details shadow_main" dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h4 className="header-title">{translate('evaluations-details')}</h4>
                                                    <p className="text-muted fs-13">
                                                        {translate('show-details')}
                                                    </p>

                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>{translate('reader_name')}</th>
                                                                    <th className="text-center">{translate('degree')}</th>
                                                                    <th className="text-center">{translate('notes')}</th>
                                                                    <th className="text-center">{translate('status')}</th>
                                                                    <th className="text-center">{translate('actions')}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!loadingevaluationDetails && evaluationDetails && (
                                                                    <>
                                                                        {/* Loop through evaluations and render rows */}
                                                                        {evaluationDetails.evaluations.map((evaluation, index) => (
                                                                            <tr className='tr-middle' key={index}>
                                                                                <th>{evaluation.readerName}</th>
                                                                                <td>{evaluation.degree}</td>
                                                                                <td>{evaluation.note}</td>
                                                                                <td ><span className={`${getBackgroundColor(evaluation.status)} div_status`} >{evaluation.status}</span></td>
                                                                                <td>
                                                                                    <div className='buttons-actions'>
                                                                                        <button className='btn-common btn-details' onClick={(e) => handleEvaluationDetails(e, evaluation.reader_id)}>{translate('details')}</button>
                                                                                        <button className='btn-common btn-reject' onClick={() => handleDelete(evaluation.reader_id)} >
                                                                                            {
                                                                                                reader_id === evaluation.reader_id ? (
                                                                                                    loadDel ? "Loading ..." : `${translate('reject')}`
                                                                                                ) : `${translate('reject')}`
                                                                                            }
                                                                                        </button>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}

                                                                        {/* Render total evaluations, number of readers, and average evaluations */}
                                                                        <tr >
                                                                            <th># {translate('total-evaluations')}</th>
                                                                            <td className={`text-nowrap ${langLocal === 'ar' ? "padding-rigth-5p" : "padding-left-5p"}`} colSpan="4">{evaluationDetails.statistics.total_evaluations}</td>

                                                                        </tr>

                                                                        <tr>
                                                                            <th># {translate('number-of-reader')}</th>
                                                                            <td className={`text-nowrap ${langLocal === 'ar' ? "padding-rigth-5p" : "padding-left-5p"}`} colSpan="4">{evaluationDetails.statistics.number_of_readers}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th># {translate('average-evaluation')}</th>
                                                                            <td className={`text-nowrap ${langLocal === 'ar' ? "padding-rigth-5p" : "padding-left-5p"}`} colSpan="4">{evaluationDetails.statistics.average_evaluations}</td>
                                                                        </tr>


                                                                        <tr>
                                                                            <th># {translate('status')}</th>
                                                                            <td className={`text-nowrap ${langLocal === 'ar' ? "padding-rigth-5p" : "padding-left-5p"}`} colSpan="4" >
                                                                                <div className="input-group">
                                                                                    <select
                                                                                        className="form-select"
                                                                                        id="statusSelect"
                                                                                        aria-label="Example select with button addon"
                                                                                        defaultValue={evaluationDetails.statistics.status}
                                                                                        onChange={(e) => handelStatusChange(e.target.value)}
                                                                                    >
                                                                                        <option value="accepted">accepted</option>
                                                                                        <option value="unaccepted">unaccepted</option>
                                                                                        <option value="reject">reject</option>
                                                                                    </select>
                                                                                    <button className='change-status-btn' onClick={handleSubmit}>{translate('change')}</button>
                                                                                </div>
                                                                                {
                                                                                    popUpActive == true && (
                                                                                        <div className='evaluation_notes' >
                                                                                            <textarea placeholder='Your Message ...' onChange={(e) => setMessage(e.target.value)} />
                                                                                        </div>
                                                                                    )
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            tab === 'script_files' && (
                                <ScriptFiles langLocal={langLocal} translate={translate} arr={arr} />
                            )
                        }
                        {
                            tab === 'script_info' && (
                                <ScriptInfo langLocal={langLocal} arr={arr} evaluationDetails={evaluationDetails} loadingevaluationDetails={loadingevaluationDetails} />
                            )
                        }
                    </div>
                </main>
            </CheckPermissions>
        </>
    );
};

export default EvaluationDetails;
